import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { traverse } from '../traverse/traverse';
var hasChildHeadingWithIndentation = function hasChildHeadingWithIndentation(node) {
  var _node$content$some, _node$content;
  return (_node$content$some = (_node$content = node.content) === null || _node$content === void 0 ? void 0 : _node$content.some(function (childNode) {
    var _childNode$marks;
    return (childNode === null || childNode === void 0 ? void 0 : childNode.type) === 'heading' && (childNode === null || childNode === void 0 ? void 0 : (_childNode$marks = childNode.marks) === null || _childNode$marks === void 0 ? void 0 : _childNode$marks.some(function (mark) {
      return mark.type === 'indentation';
    }));
  })) !== null && _node$content$some !== void 0 ? _node$content$some : false;
};
var removeIndentationFromHeadings = function removeIndentationFromHeadings(node) {
  var _node$content2;
  return _objectSpread(_objectSpread({}, node), {}, {
    content: (_node$content2 = node.content) === null || _node$content2 === void 0 ? void 0 : _node$content2.map(function (childNode) {
      if ((childNode === null || childNode === void 0 ? void 0 : childNode.type) === 'heading') {
        var _childNode$marks2;
        return _objectSpread(_objectSpread({}, childNode), {}, {
          marks: (_childNode$marks2 = childNode.marks) === null || _childNode$marks2 === void 0 ? void 0 : _childNode$marks2.filter(function (mark) {
            return mark.type !== 'indentation';
          })
        });
      }
      return childNode;
    })
  });
};
export var transformIndentationMarks = function transformIndentationMarks(adf) {
  var isTransformed = false;
  var transformedAdf = traverse(adf, {
    tableCell: function tableCell(node) {
      if (hasChildHeadingWithIndentation(node)) {
        isTransformed = true;
        return removeIndentationFromHeadings(node);
      }
    },
    tableHeader: function tableHeader(node) {
      if (hasChildHeadingWithIndentation(node)) {
        isTransformed = true;
        return removeIndentationFromHeadings(node);
      }
    }
  });
  return {
    transformedAdf: transformedAdf,
    isTransformed: isTransformed
  };
};